import type { ComputedRef, Ref } from "vue";
import { DSSelectModelValue, DSSelectProps } from "@/src/design_system/form_elements/select/types/props";
import { DSSelectEmits } from "@/src/design_system/form_elements/select/types/emits";

interface UseSelectClearSelectionArgs {
  modelValue: Ref<DSSelectModelValue>;
  props: ComputedRef<Readonly<DSSelectProps>>;
  emit: DSSelectEmits;
  clearSearch: () => void;
  activeOptionId: Ref<string | undefined>;
}

interface UseSelectClearSelection {
  clearSelection: () => void;
}

export const useSelectClearSelection = ({
  modelValue,
  props,
  emit,
  clearSearch,
  activeOptionId,
}: UseSelectClearSelectionArgs): UseSelectClearSelection => {
  const clearSelection = () => {
    if (props.value.multiple) {
      modelValue.value = [];
    } else {
      modelValue.value = null;
    }

    clearSearch();
    emit("search", "");
    activeOptionId.value = undefined;
  };

  return { clearSelection };
};
